import { render, staticRenderFns } from "./editruleofmetadata.vue?vue&type=template&id=31e29e6d"
import script from "./editruleofmetadata.vue?vue&type=script&lang=js"
export * from "./editruleofmetadata.vue?vue&type=script&lang=js"
import style0 from "./editruleofmetadata.vue?vue&type=style&index=0&id=31e29e6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports